import { Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../ConfigFields/SelectField';

export function FeedMessagesFormFields() {
  return (
    <>
      <Stack>
        <Text>
          The Entity Type, Entity ID, and Practice ID are inferred from the entity used to start the
          flow. Additional filters can be configured below. Messages are sorted descendingly by
          created date, so the newest message will appear first in the array.
        </Text>
      </Stack>
      <Stack direction="column" spacing={2}>
        <BlockValueTemplateField fieldName="config.source" label="Source" />
        <BlockValueTemplateField
          fieldName="config.limit"
          label="Limit"
          helperText="Limit the number of messages to return."
        />
        <BlockSelectField
          fieldName="config.messageFormat"
          label="Message Format"
          options={Object.entries(api.FeedMessage.FeedMessageFormat).map(([key, value]) => ({
            label: key,
            value,
          }))}
          required
        />
      </Stack>
    </>
  );
}
